import {createContext} from 'react';
import {
   FarmFragment, FarmPageFragment,
} from '../generated/types';

interface FarmContextType {
  farm?: FarmFragment | FarmPageFragment['farm']
}

export const FarmContext = createContext<FarmContextType>({});
